<template>
  <div class="page-poster"  v-loading="loading">
    <div class="tab-content" id="posterHtml">


      <!-- 社交 -->
      <transition enter-active-class="animated fadeIn">
        <div class="cont shejiao" v-if="showIndex === 0">
          <div class="user-info">
            <div class="avatar"><img :src="imgUrl" alt=""></div>
            <div class="name">{{posterName}}</div>
            <div class="inv">请您一起快乐学习~</div>
          </div>
          <div class="article-img"><img :src="posterImageUrl" alt=""></div>
          <div class="article-title">{{posterName}}</div>
<!--          <div class="article-teacher">主讲：{{psoterInfo.creatorName}}</div>-->
<!--          <div class="article-teacher" v-if="psoterInfo.classificationOf==11">开始时间：{{course.showTime}}</div>-->
          <div class="erweima">
            <div class="qr-code" ><div id="qrcodeImg0"></div></div>
            <img class="qr-logo" :src="require('@/assets/images/poster_logo.png')" alt="">
          </div>
        </div>
      </transition>
      <!-- 简约 -->
      <transition enter-active-class="animated fadeIn">
        <div class="cont jianyue" v-if="showIndex ===1">
          <img class="jianyue-logo" :src="require('@/assets/images/poster_logo.png')" alt="">
          <div class="tit">课程二维码</div>
          <div class="qr-code"><div id="qrcodeImg1"></div></div>
<!--          <div class="article-tit">{{course.courseName}}</div>-->
<!--          <div class="article-tit" v-if="course.classificationOf==11">开始时间：{{course.showTime}}</div>-->

        </div>
      </transition>
      <!-- 插画 -->
      <transition enter-active-class="animated fadeIn">
        <div class="cont chahua" v-if="showIndex === 2">
          <img class="chahua-logo" :src="require('@/assets/images/guli_logo.png')" alt="">
          <div class="slogn">
            <span>思想以自己的言语喂养它自己，而成长起来。</span>
            <span class="name"> —— 泰戈尔</span>
          </div>
          <div class="bott-info">
            <div class="tit-teacher">
              <div class="">{{posterName}}</div>
              <div class="teacher">主讲：12312312</div>
<!--              <div class="teacher" v-if="course.classificationOf==11">开始时间：{{course.showTime}}</div>-->

            </div>
            <div class="qr-code"><div id="qrcodeImg2"></div></div>
          </div>
        </div>
      </transition>
      <!-- 鼓励 -->
      <transition enter-active-class="animated fadeIn">
        <div class="cont guli" v-if="showIndex === 3">
          <img class="guli-logo" :src="require('@/assets/images/guli_logo.png')" alt="">
          <div class="top">
            <div class="mask">
              <span>智慧是命运的一部分，一个人所遭遇的外界环境是会影响他的头脑的。</span>
              <span> —— 莎士比亚</span>
            </div>
          </div>
          <div class="bott">
            <div class="tit-name">
              <div class="tit">{{posterName}}</div>
<!--              <div class="name">主讲：{{psoterInfo.creatorName}}</div>-->
<!--              <div class="name" v-if="psoterInfo.classificationOf==11">开始时间：{{psoterInfo.showTime}}</div>-->

            </div>
            <div class="qr-code" ><div id="qrcodeImg3"></div></div>
          </div>
        </div>
      </transition>
    </div>
    <ul class="bottom-cont" >
      <div class="sc-btn" @click="createPcPoster" v-if="!isMobile"><el-button type="primary">生成海报</el-button></div>
      <div class="sc-btn" @click="createAppPoster" v-if="isMobile"><el-button type="primary">生成海报</el-button></div>
      <div class="tab-item"
        :class="{'active': showIndex === index ? true : false}"
        v-for="(item, index) in selectInfo"
        :key="index"
        @click="select(index)"
      >
        <div class="tab-img" :style="{'background-image': 'url(' + item.imgSrc + ')'}"></div>
        <div class="words">{{item.tit}}</div>
      </div>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
//import "../../../static/css/animate.min.css"
import axios from 'axios';
import vue from 'vue';
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
vue.prototype.$axios = axios;
import qs from 'qs';
vue.prototype.qs = qs;
import VueCookies from 'vue-cookies'
vue.use(VueCookies);
export default {
  components: {

  },
  data () {
    return {
      id:'',
      imgUrl:"",
      showIndex: 0,
      posterName:"",
      posterImg: '',
      postUrl:'',
      posterImageUrl:'',
      img_url64:'',
      isMobile:false,
      loading: true,
      selectInfo: [

        {
          tit: '默认',
          imgSrc: require('@/assets/images/poster_sl02.jpg')
        },
        {
          tit: '风格1',
          imgSrc: require('@/assets/images/poster_sl01.jpg')
        },
        {
          tit: '风格2',
          imgSrc: require('@/assets/images/poster_sl03.jpg')
        },
        {
          tit: '风格3',
          imgSrc: require('@/assets/images/poster_sl04.jpg')
        }
      ]
    }
  },
  mounted () {
    this.id=this.$route.query.id;
    // this.getPoster(this.id);
    this.select (0)
    this.postUrl="http://www.renrendonghua.com/activities/matchs/detail?id="+this.id;

    if(this._isMobile()){
      this.isMobile=true;
    }else{
      this.isMobile=false;
    }
  },

  methods: {
    select (index) {
      this.loading=true;
      this.showIndex = index
      console.log(index)
      this.$nextTick(()=>{

        this.createQrcode( this.postUrl,this.showIndex);
      });

    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    createQrcode(text,index) {
      let _this=this;
      let url="/rrbi/poster/archive?id="+_this.id+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        if(result.data.code==1){
          _this.posterName=result.data.response.activityName;
          _this.imgUrl="http://iss.21teacher.com/avatar/125/"+result.data.creatorId+"/0.jpg";
          _this.posterImageUrl=result.data.response.posterImageUrl;
        }else{
          _this.$router.push({
            path:'/error',
          })
        }
        const qrcodeImgEl = document.getElementById('qrcodeImg'+index)
        console.log('qrcodeImg'+index)
        qrcodeImgEl.innerHTML = ''
        let qrcode = new this.QRCode(qrcodeImgEl, {
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
        qrcode.makeCode(text);
        setTimeout(function (){
          _this.loading=false;
        },"1000");
        // _this.$nextTick(function () {
        //
        // })

      })
      // 生成二维码

    },
    createAppPoster() {
      let _this=this;
      // 生成海报
      const vm = this
      const domObj = document.getElementById('posterHtml')
      html2canvas(domObj, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        onclone(doc) {
          let e = doc.querySelector('#posterHtml')
          e.style.display = 'block'
        }
      }).then(function(canvas) {
        _this.$nextTick(()=>{
          _this.img_url64= canvas.toDataURL('image/png')
          _this.$alert('<img style="margin: 0 auto;width: 200px;" src="'+ _this.img_url64+'"><a id="downUrl" @click = “download”></a><span style="display:block;font-size: 12px;color: #ff0000;">长按上方图片保存</span>', '分享海报', {
            dangerouslyUseHTMLString: true,
            showConfirmButton:false,
            center: true,
          })

        });

      }).catch(() => {
          console.log("出错了")
      });
    },
    createPcPoster() {
      let _this=this;
      // 生成海报
      const vm = this
      const domObj = document.getElementById('posterHtml')
      html2canvas(domObj, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        onclone(doc) {
          let e = doc.querySelector('#posterHtml')
          e.style.display = 'block'
        }
      }).then(function(canvas) {
        _this.$nextTick(()=>{
          _this.img_url64= canvas.toDataURL('image/png')
          _this.$confirm('<a id="downUrl" @click = "download"><img style="margin: 0 auto;width: 200px;" src="'+ _this.img_url64+'"></a>', '分享海报', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '下载',
            cancelButtonText: '取消',
            center: true,
          }).then(() => {
            _this.download();
          });

        });

      })
    },
    download() {
      let imgData = this.img_url64;
      this.downloadFile(this.course.courseName+".png", imgData);
    },
    //下载
    downloadFile(fileName, content) {
      if (window.navigator.msSaveOrOpenBlob) {
        var bstr = atob(content.split(',')[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        var blob = new Blob([u8arr])
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        let aLink = document.createElement('a');
        let blob = this.base64ToBlob(content); //new Blob([content]);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        aLink.download = fileName;
        aLink.href = URL.createObjectURL(blob);
        aLink.click()
      }

      // aLink.dispatchEvent(evt);
      // aLink.click()

      // aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },

    getPoster(){
      let _this=this;
      let url="/rrbi/activity/activity-one?id="+_this.id+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        console.log(result.data)
        if(result.data.code==1){
          _this.posterName=result.data.response.activityName;
          _this.imgUrl="http://iss.21teacher.com/avatar/125/"+result.data.creatorId+"/0.jpg";
          _this.posterImageUrl=result.data.response.posterImageUrl;
          _this.createQrcode(_this.postUrl,_this.showIndex);
        }else{
          _this.$router.push({
            path:'/error',
          })
        }

      })

    }
  }
}
</script>

<style scoped lang="less">
  @media screen and (max-width: 750px){
    .page-poster{
      width: 100%;
      height: 100vh;
    }
  }
  @media screen and (min-width: 751px){
    .page-poster{
      margin: 0 auto;
      width: 500px;
      height: 100vh;
    }
  }
  .page-poster{
    overflow: hidden;
    position: relative;
    background: #333;
    .tab-content{
      margin: 10% auto 0;
      width: 80%;
      height: 70%;
      background: #fff;
      .cont{
        position: relative;
        width: 100%;
        height: 100%;
        &.jianyue{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: url('../../assets/images/jianyue_bg.jpg');
          background-size: 100% 100%;
          .jianyue-logo{
            position: absolute;
            left: 10px;top: 20px;
            width: 20%;
          }
          .tit{
            color: #333;
            font-size: 14px;
          }
          .qr-code{
            margin: 20px 0;
            flex: 0 0 100px;
            width: 100px;
            height: 100px;
            background: pink;
          }
          .article-tit{
            color: #333;
            font-size: 14px;
            font-weight: bold;
          }
        }
        &.shejiao{
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 20px 10px;
          /*background: #fff url('../../assets/images/poster_shejiao_bg.jpg') center bottom no-repeat;*/
          background-color: #fff;
          background-image: url('../../assets/images/poster_shejiao_bg.jpg');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          .user-info{
            display: flex;
            align-items: center;
            font-size: 12px;
            .avatar{
              overflow: hidden;
              flex: 0 0 40px;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              img{
                width: 100%
              }
            }
            .name{
              margin: 0 10px;
              color: #070707;
              font-weight: bold;
            }
            .inv{
              color: #272727;
            }
          }
          .article-img{
            overflow: hidden;
            margin-top: 10px;
            padding-bottom: 63.6363636363%;
            height: 0;
            border-radius: 5px;
            img{
              width: 100%;
            }
          }
          .article-title{
            margin: 10px 0 5px;
            color: #010101;
            font-size: 14px;
            font-weight: bold;
          }
          .article-teacher{
            color: #666;
            font-size: 12px;
          }
          .erweima{
            display: flex;
            flex-direction: column;
            align-items: center;
            .qr-code{
              flex: 0 0 100px;
              margin-bottom: 10px;
              width: 100px;
              height: 100px;
              background: pink;
            }
            .qr-logo{
              width: 20%;
            }
          }
        }
        &.chahua{
          /*background: #eb992d url('../../assets/images/poster_chahua_bg.jpg') center top;*/
          background-color: #eb992d;
          background-image: url('../../assets/images/poster_chahua_bg.jpg');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          .chahua-logo{
            position: absolute;
            z-index: 2;
            left: 10px;top: 20px;
            width: 20%;
          }
          .slogn{
            position: absolute;
            bottom: 32.5%;
            left: 5%;
            width: 90%;
            span{
              display: block;
              margin-bottom: 5px;
              color: #fff;
              font-size: 14px;
              &.name{
                text-align: right;
              }
            }
          }
          .bott-info{
            position: absolute;
            bottom: 0;
            left: 5%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 10% 0 9%;
            width: 90%;
            height: 32.5%;
            background: url('../../assets/images/chahua_info_bg.png');
            background-size: 100% 100%;
            .tit-teacher{
              flex: 1;
              margin-right: 5px;
              .tit{
                margin-bottom: 10px;
                color: #010101;
                font-size: 14px;
                font-weight: bold;
              }
              .teacher{
                display: flex;
                font-size: 12px;
                .tt{
                  flex: 0 0 40px;
                  width: 40px;
                  line-height: 20px;
                }
              }
            }
            .qr-code{
              flex: 0 0 100px;
              width: 100px;
              height: 100px;
              background: pink;
            }
          }
        }
        &.guli{
          .guli-logo{
            position: absolute;
            z-index: 2;
            left: 10px;top: 20px;
            width: 20%;
          }
          .top{
            position: relative;
            height: 73%;
            background-image: url('../../assets/images/guli_bg.jpg');
            background-size: 100% 100%;
            .mask{
              position: absolute;
              left: 0;top: 0;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-end;
              padding: 0 20px;
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, .35);
              span:last-child{
                text-align: right;
              }
            }
            span{
              display: block;
              margin: 20px 0;
              width: 100%;
              color: #fff;
              font-size: 14px;
              line-height: 30px;
            }
          }
          .bott{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            height: 27%;
            .tit-name{
              flex: 1;
              .tit{
                font-size: 14px;
                font-weight: bold;
              }
              .name{
                display: flex;
                margin-top: 10px;
                font-size: 12px;
                .tt{
                  flex: 0 0 40px;
                  width: 40px;
                  line-height: 20px;
                }
              }
            }
            .qr-code{
              flex:  0 0 100px;
              margin-left: 20px;
              width: 100px;
              height: 100px;
              background: pink;
            }
          }
        }
        .text-ell{
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-break: break-all;
          line-height: 20px;
          max-height: 40px;
        }
      }
    }
    .bottom-cont{
      position: absolute;
      bottom: 0;
      left: 0;
      padding-top: 10px;
      display: flex;
      align-items: center;
      width: 100%;
      height: 18%;
      background: #fff;
      .sc-btn{
        position: absolute;
        left: 50%;
        top: 0;
        margin-left: -50px;
        width: 100px;
        transform: translateY(-100%);
        button{
          width: 100%;
        }
      }
      .tab-item{
        flex: 1;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        .tab-img{
          margin: 0 auto;
          padding-bottom: 80%;
          width: 80%;
          height: 0;
          background-size: 100% 100%;
          box-sizing: border-box;
          cursor: pointer;
          img{
            width: 100%;
          }
        }
        .words{
          margin: 5px 0;
          text-align: center;
          font-size: 12px;
        }
        &.active{
          .tab-img{
            position: relative;
            &:after{
              position: absolute;
              content: '';
              display: block;
              width: 100%;
              height: 100%;
              border: 3px solid #409eff;
            }
          }
        }
      }
    }
  }
</style>
